import {
  ACCIDENT_ABOUT_STEP,
  ACCIDENT_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/Accident/accidentSteps";
import { AccidentProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/ProductIntro/accidentProductIntroFormValues";
import { AccidentProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/ProductPrice/accidentProductPriceFormValues";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";

export function mapFromCommerceAccident(data: Record<string, any>): FormStates {
  return {
    [ACCIDENT_ABOUT_STEP.id]: <AccidentProductIntroFormValues>{
      isInsuredOwner: booleanToFormBoolean(data.isInsuredOwner),
      insuredOwnerAge:
        !data.isInsuredOwner && data.insuredOwnerAge
          ? Number(data.insuredOwnerAge)
          : undefined,
    },
    [ACCIDENT_PRICE_STEP.id]: <AccidentProductPriceFormValues>{
      coverage: data.coverageGroup,
      deathCoverageAmount: data.deathCoverageAmount,
      disabilityCoverageAmount: data.disabilityCoverageAmount,
    },
  };
}
